import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import { HomePage } from "./screens/HomePage/HomePage"; // Import HomePage
import './tailwind.css';

// Wrap your app with BrowserRouter to provide routing context
createRoot(document.getElementById("app") as HTMLElement).render(
  <StrictMode>
    <BrowserRouter> {/* Wrap HomePage with BrowserRouter */}
      <HomePage />
    </BrowserRouter>
  </StrictMode>
);
